import { render, staticRenderFns } from "./OmxCommandPalette.vue?vue&type=template&id=02d2326a&scoped=true"
import script from "./OmxCommandPalette.vue?vue&type=script&lang=js"
export * from "./OmxCommandPalette.vue?vue&type=script&lang=js"
import style0 from "./OmxCommandPalette.vue?vue&type=style&index=0&id=02d2326a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d2326a",
  null
  
)

export default component.exports